/// <reference path="../../../../typings/index.d.ts" />
module Meevo.Plugins.RatingsControlPanel {

    import Client = Meevo.Model.Client;
    import VerbEnum = Meevo.Model.VerbEnum;
    import NounEnum = Meevo.Model.NounEnum;

    export class RatingsControlPanelController {
        static $inject = [
            '$rootScope',
            '$state',
            '$q',
            '$translate',
            'meevo.components.busy.BusyService',
            'meevo.components.common.SecurityService',
            'meevo.components.common.DataService',
            'meevo.AppSettings',
            'meevo.components.common.IdentityService',
            'meevo.components.modal.ModalService',
            'meevo.components.tracking.TrackingService',
            '$mdSidenav',
        ];

        public criteria: RatingControlPanelCriteriaModel;
        public viewTypeModel: DataListViewTypesEnum;
        public viewType: DataListViewTypesEnum;
        public itemsCount: number = null;
        public ratingItems: IRating[];
        public selectedClient: IRatingSelectedClient;

        public employeeSecurity: boolean = true;
        public clientSecurity: boolean = true;
        public commentSecurity: boolean = true;

        public displayType: DisplayRatingTypesEnum;

        public get basePoint(): string {
            if (this.viewTypeModel === DataListViewTypesEnum.Detailed) {
                return `${this.appSettings.API_ENDPOINTS.ratings}/Detail`;
            }

            return `${this.appSettings.API_ENDPOINTS.ratings}/Summary`;
        }

        public get selectedCount(): number {
            if (!this.ratingItems || !this.ratingItems.length) {
                return 0;
            }

            return this.ratingItems.filter((r) => r.isSelected).length;
        }


        public checkSecurity() {
            this.securityService
                .checkSecurityKey(Meevo.Components.Common.SecurityKeys.MANAGEMENT_RATINGSCONTROLPANEL_ACTION_VIEWALLEMPLOYEESRATINGS)
                .then((item) => {
                    this.employeeSecurity = item === Model.SecurityAccessEnum.Grant;
                });
            this.securityService
                .checkSecurityKey(Meevo.Components.Common.SecurityKeys.MANAGEMENT_RATINGSCONTROLPANEL_FIELD_CLIENTNAME + Meevo.Components.Common.SecurityParts.KEY_PART_READ)
                .then((item) => {
                    this.clientSecurity = item === Model.SecurityAccessEnum.Grant;
                });
            this.securityService
                .checkSecurityKey(Meevo.Components.Common.SecurityKeys.MANAGEMENT_RATINGSCONTROLPANEL_FIELD_COMMENT + Meevo.Components.Common.SecurityParts.KEY_PART_READ)
                .then((item) => {
                    this.commentSecurity = item === Model.SecurityAccessEnum.Grant;
                });
        }

        public get isDetailedView(): boolean {
            return this.viewType === DataListViewTypesEnum.Detailed
        }

        public get isPublishUnpublishFilter(): boolean {
            return this.displayType === DisplayRatingTypesEnum.Published || this.displayType === DisplayRatingTypesEnum.Unpublished
        }

        public isSidebarOpen: boolean;

        constructor(private $rootScope: angular.IRootScopeService,
                    private $state: angular.ui.IStateService,
                    private $q: ng.IQService,
                    private $translate: angular.translate.ITranslateService,
                    private busyService: Meevo.Components.Busy.IBusyService,
                    private securityService: Meevo.Components.Common.ISecurityService,
                    private dataService: Meevo.Components.BaseClasses.IDataService,
                    private appSettings: Components.Common.IAppSettings,
                    private identityService: Meevo.Components.Common.IIdentityService,
                    private modalService: Meevo.Components.Modal.IModalService,
                    private trackingService: Meevo.Components.Tracking.ITrackingService,
                    private $mdSidenav) {
            this.criteria = new RatingControlPanelCriteriaModel(<any>{
                rating: null,
                displayType: DisplayRatingTypesEnum.All,
                pageNumber: 0,
                itemsPerPage: 25,
                showActiveEmployee: true,
                showInactiveEmployee: false
            });
            this.viewType = DataListViewTypesEnum.Detailed;
            this.viewTypeModel = DataListViewTypesEnum.Detailed;
            this.displayType = DisplayRatingTypesEnum.All;
            this.checkSecurity();
            setTimeout(() => {
                if (!this.ratingItems) {
                    this.toggleSidebar();
                }
            }, 1000);
        }

        public closeContext() {
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state.current, null);
        }

        public search(isPage = false) {
            this.busyService.start();
            if (!isPage) {
                this.criteria.pageNumber = 0;
            }

            this.selectedClient = null;

            let criteria = this.criteria.getCriteria(this.viewTypeModel === DataListViewTypesEnum.Detailed);

            const trackInfo = new Meevo.Model.TrackingItem(NounEnum.RatingsControlPanel, VerbEnum.SearchButtonClicked, criteria);
            this.trackingService.saveTrackingInfo(trackInfo);

            this.dataService.getCount(this.basePoint, criteria)
                .then((count) => {
                    this.itemsCount = count;

                    return this.dataService.getListPaged(this.basePoint, criteria);
                })
                .then((items: IRating[]) => {
                    this.viewType = this.viewTypeModel;
                    this.displayType = this.criteria.displayType;
                    this.ratingItems = items;
                })
                .finally(() => {
                    this.busyService.stop();
                    this.closeSidebar();
                });
        }

        public pageChanged() {
            this.search(true);
        }

        public showClientDetail(clientId: string) {
            if (this.selectedClient && this.selectedClient.clientInfo.id === clientId) {
                return;
            }

            this.securityService
                .checkSecurityItemWithElevation(Meevo.Components.Common.SecurityKeys.DATA_CLIENT + Meevo.Components.Common.SecurityParts.KEY_PART_READ)
                .then(() => this.$q.all([
                    this.dataService.getItem(this.appSettings.API_ENDPOINTS.ratingClientSummary, <any>clientId),
                    this.getClientById(<any>clientId)
                ]))
                .then((res: any) => {
                    this.selectedClient = {
                        summary: res[0],
                        clientInfo: res[1]
                    };
                });
        }

        public switchDeleted(rating: IRating) {
            rating.isDeleted = !rating.isDeleted;
            if (rating.isDeleted) {
                rating.isHidden = true;
            }
            this.updateRatings([rating])
                .then(() => this.search());
        }

        public publishSelected() {
            let selected = this.ratingItems.filter((r) => r.isSelected);
            if (selected.length === 0) {
                this.modalService.alert('MESSAGE_SELECT_RATING_TO_BE_PUBLISHED');

                return;
            }

            selected.forEach((r) => {
                r.isHidden = false;
                r.isSelected = false;
            });

            this.updateRatings(selected)
                .then(() => {
                    let message = this.$translate.instant('LABEL_SUCCESS_PUBLISHED_RATINGS', {val: selected.length});

                    return this.modalService.alert(message);
                })
                .then(() => this.search());
        }

        public unpublishSelected() {
            let selected = this.ratingItems.filter(r => r.isSelected);
            if (selected.length === 0) {
                this.modalService.alert('MESSAGE_SELECT_RATING_TO_BE_UNPUBLISH');

                return;
            }

            selected.forEach((r) => {
                r.isHidden = true;
                r.isSelected = false;
            });

            this.updateRatings(selected)
                .then(() => {
                    let message = this.$translate.instant('LABEL_SUCCESS_UNPUBLISHED_RATINGS', {val: selected.length});

                    return this.modalService.alert(message);
                })
                .then(() => this.search());
        }

        private getClientById(id: Guid): ng.IPromise<Client> {
            return this.dataService.getItem(this.appSettings.API_ENDPOINTS.client, id)
                .then((client: any) => {
                    client.primaryPhoneNumberObj = client.phoneNumbers.find((phone) => phone.isPrimary === true);

                    return <Client>client;
                });
        }

        public toggleSidebar() {
            this.$mdSidenav('ratings-filter').toggle();
        }

        public closeSidebar() {
            if (this.isSidebarOpen) {
                this.$mdSidenav('ratings-filter').close();
            }
        }

        public saveReply(rating: IRating): void {
            this.updateRatings([rating])
                .then(() => this.search());
        }

        public exportCsv() {
            this.busyService.start();
            let criteria = this.criteria.getCriteria(true);
            criteria.itemsPerPage = 999999;
            let uri = `/${this.appSettings.API_ROOT}/${this.appSettings.API_ENDPOINTS.ratings}/detail/export`;
            this.dataService
                .customMethodData(uri, 'POST', criteria)
                .then((res) => {
                    this.busyService.stop();
                    setTimeout(() => {
                        Meevo.Components.Common.Utilities.downloadFile(null, res.data, 'clients-export.csv');
                    }, 1);
                });
        }

        private updateRatings(ratings: IRating[]) {
            this.busyService.start();

            return this.dataService
                .customMethodData(`/${this.appSettings.API_ROOT}/${this.appSettings.API_ENDPOINTS.ratings}`, 'POST', {
                    employee_User_TId: this.identityService.current().userId,
                    saleLineRatings: ratings
                })
                .finally(() => this.busyService.stop());
        }
    }

    angular.module('meevo.plugins.ratingsControlPanel')
        .controller('meevo.plugins.ratingsControlPanel.RatingsControlPanelController', RatingsControlPanelController);
}
